import {
  EDIT_QUIZZ,
  EDIT_QUIZZ_SUCCESS,
  EDIT_QUIZZ_CLEAN,
  EDIT_QUIZZ_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  quizz: undefined,
}

const QuizzEdit = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_QUIZZ:
      state = {
        ...state,
        loading: true,
      }
      break
    case EDIT_QUIZZ_SUCCESS:
      state = {
        ...state,
        quizz: action.payload.quizz,
        loading: false,
        done: true,
      }
      break
    case EDIT_QUIZZ_CLEAN:
      state = initialState
      break
    case EDIT_QUIZZ_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        done: false,
        quizz: undefined,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default QuizzEdit
